import { render, staticRenderFns } from "./IconErrorLamp.vue?vue&type=template&id=0f9c1d20&"
import script from "./IconErrorLamp.vue?vue&type=script&lang=js&"
export * from "./IconErrorLamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports